const attributeName = 'data-balance';

const extractPrice = (priceElement) => {
  const price = priceElement.getAttribute(attributeName);
  return price || '';
};

const changePrice = (priceElement, { convertedPrice }) => {
  const currentHtmlPrice = priceElement.getAttribute(attributeName);
  const wholeElementText = priceElement.textContent;
  priceElement.textContent = wholeElementText.replace(
    currentHtmlPrice,
    convertedPrice
  );
  priceElement.setAttribute(attributeName, convertedPrice);
};

const matchType = (selector) =>
  selector.classList.contains('ec-applied-giftcard-message');

export default {
  matchType,
  extractPrice,
  changePrice,
  name: 'discountGiftcard',
};
